import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { PurchasingService } from '../../../services/purchasing.service';
import { PrintService } from '../../../services/print.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';

@Component({
	selector: 'app-vendordash-invoice-issues',
	templateUrl: './vendordash-invoice-issues.component.html',
	styleUrls: ['./vendordash-invoice-issues.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
		]),
	]
})
export class VendordashInvoiceIssuesComponent implements OnInit {
	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();
	viewing: any = false;

	data: any = [];
	title = 'Invoice Issues';
	exporting = false;
	@ViewChild('print_table') printtable: ElementRef;

	constructor(
		private purchasingService: PurchasingService,
		private printService: PrintService,
		private globalSearchService: GlobalSearchService
	) {}

	getDifference(ordered: any, received: any): number {
		return parseFloat(ordered) - parseFloat(received);
	}

	ngOnInit(): void {
		this.purchasingService.getPurchaseOrders().subscribe((results: any) => {
			if (results && results.grnready) {
				this.data = results.grnready.filter((i: any) => {
					return parseFloat(i.quantityord) != parseFloat(i.qtyrecd) && parseFloat(i.qtyrecd) > 0;
				});
			}
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: this.title };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}

	exportPdf() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'invoice-issues.pdf',
			landscape: true,
			title: 'Invoice Issues',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'invoice-issues.xlsx',
			title: 'Invoice Issues',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exporting = false;
		});
	}
}
